window.addEventListener('DOMContentLoaded', () => {
  const cardsWrapper = document.querySelector('[data-customer-stories-cards]');
  const jsonEl = document.querySelector('[data-customer-stories-json]');

  if (!cardsWrapper || !jsonEl) return;

  let customerStoriesJson = {};
  try {
    customerStoriesJson = JSON.parse(jsonEl.textContent || jsonEl.text || '{}');
  } catch (error) {
    customerStoriesJson = {};
  }

  const modalEle = document.querySelector('#people-love-dialog');
  const modalData = document.querySelector('#people-love-dialog [data-modal-data]');
  const pageSize = Number(cardsWrapper.dataset.pageSize || 24);

  let paginationTrigger = document.querySelector('[data-load-more]');
  let isLoadingMore = false;
  let loadObserver = null;

  const storyRevealTrigger = document.querySelector('[data-load-more-story]');
  if (storyRevealTrigger) {
    storyRevealTrigger.addEventListener('click', (e) => {
      const hiddenCards = document.querySelectorAll('.story--card.load-more-items');
      if (!hiddenCards.length) return;
      e.preventDefault();
      hiddenCards.forEach((card) => card.classList.remove('load-more-items'));
    });
  }

  initModal(document.querySelectorAll('[data-modal-opener="people-love-dialog"]'));

  function sortCardsNewestFirst() {
    const cards = Array.from(cardsWrapper.querySelectorAll('.story--card'));
    if (cards.length < 2) return;

    // Newest added first: higher metaobject system.id = more recently created
    cards.sort((a, b) => Number(b.dataset.storySortId || 0) - Number(a.dataset.storySortId || 0));

    const anchor = cardsWrapper.querySelector('[data-customer-stories-json]');
    const fragment = document.createDocumentFragment();
    cards.forEach((card, index) => {
      const shouldDefer = index >= pageSize;
      card.classList.toggle('customer-stories-deferred', shouldDefer);
      card.classList.toggle('d-none', shouldDefer);
      fragment.appendChild(card);
    });
    if (anchor) {
      cardsWrapper.insertBefore(fragment, anchor);
    } else {
      cardsWrapper.appendChild(fragment);
    }
  }

  function disconnectLoadObserver() {
    if (loadObserver) {
      loadObserver.disconnect();
      loadObserver = null;
    }
    if (paginationTrigger) paginationTrigger._loadMoreObserver = null;
  }

  function getDeferredCards() {
    return cardsWrapper.querySelectorAll('.customer-stories-deferred');
  }

  function clearPagination() {
    disconnectLoadObserver();
    document.querySelector('[data-customer-stories-pagination]')?.remove();
    paginationTrigger = null;
  }

  function revealMoreStories() {
    if (isLoadingMore) return;

    const deferred = getDeferredCards();
    if (!deferred.length) {
      clearPagination();
      return;
    }

    isLoadingMore = true;
    disconnectLoadObserver();

    Array.from(deferred)
      .slice(0, pageSize)
      .forEach((card) => {
        card.classList.remove('customer-stories-deferred', 'd-none');
      });

    isLoadingMore = false;

    if (!getDeferredCards().length) {
      clearPagination();
      return;
    }

    if (paginationTrigger) armLoadMore(paginationTrigger, true);
  }

  function observeLoadMore(btn) {
    if (!btn || isLoadingMore) return;

    disconnectLoadObserver();

    loadObserver = new IntersectionObserver((entries, observer) => {
      if (!entries.some((entry) => entry.isIntersecting) || isLoadingMore) return;
      observer.disconnect();
      loadObserver = null;
      btn._loadMoreObserver = null;
      revealMoreStories();
    }, {
      rootMargin: '0px',
      threshold: 0
    });

    btn._loadMoreObserver = loadObserver;
    loadObserver.observe(btn);
  }

  function armLoadMore(btn, waitUntilHidden) {
    if (!btn) return;
    disconnectLoadObserver();

    const rect = btn.getBoundingClientRect();

    if (!waitUntilHidden || rect.top >= window.innerHeight) {
      observeLoadMore(btn);
      return;
    }

    const exitObserver = new IntersectionObserver((entries) => {
      if (!entries.some((entry) => !entry.isIntersecting)) return;
      exitObserver.disconnect();
      observeLoadMore(btn);
    }, {
      rootMargin: '0px',
      threshold: 0
    });
    exitObserver.observe(btn);
  }

  function createModalHtml(data) {
    const stars = Math.max(0, Math.min(5, Number(data.reviews_stars) || 0));
    const empty = 5 - stars;

    return `
      <div class="row mt-5 mt-md-7">
        <div class="col-md-6">
          <div class="swiper-wrapper__custom">
            <div class="custom-swiper-navigation d-flex justify-content-between align-items-center position-absolute z-2 w-100">
              <button class="swiper-button-prev btn-prev-stories"><svg aria-hidden="true" focusable="false"><use href="#icon-arrow-left"></use></svg></button>
              <button class="swiper-button-next btn-next-stories"><svg aria-hidden="true" focusable="false"><use href="#icon-arrow-right"></use></svg></button>
            </div>
            <swiper-container class="swiper swiper-slider overflow-hidden"
              loop="false"
              grabCursor="true"
              pagination="false"
              navigation='{"nextEl":".btn-next-stories","prevEl":".btn-prev-stories"}'
              spaceBetween="0"
              slidesPerView="1"
            >
              ${data.images ? data.images.map((img) => `
                <swiper-slide class="swiper-slide">
                  <div class="review-gallery overflow-hidden mx-auto">
                    <img
                      srcset="
                        ${img}&width=400 400w,
                        ${img}&width=450 450w,
                        ${img}&width=550 550w,
                        ${img}&width=600 600w,
                        ${img}&width=650 650w,
                        ${img}&width=720 720w"
                      src="${img}&width=400"
                      sizes="(min-width: 1440px) 474px, (min-width: 992px) calc((100vw - 30px) / 2), 100vw"
                      alt=""
                      title="${data.reviewer_name || ''}"
                      class="w-100 h-100 object-fit-contain"
                      loading="lazy"
                      width="1000"
                      height="1000"
                    >
                  </div>
                </swiper-slide>`).join('') : '<p>No image found</p>'}
            </swiper-container>
          </div>
        </div>
        <div class="col-md-6">
          <div class="ps-md-4 pt-4 pt-md-0">
            <div class="custom-reviews mb-3 mb-md-4 lh-1">
              ${Array(stars).fill('<i class="text-warning icon-size-18 dr-icon-star-fill"></i>').join('')}
              ${Array(empty).fill('<i class="text-warning icon-size-18 dr-icon-star"></i>').join('')}
            </div>
            <h4 class="mb-3">${data.title || ''}</h4>
            ${data.body_text ? `
              <div class="mb-4 mb-md-7">
                <description-toggle class="d-block">
                  <div class="d-none d-md-block" data-description>
                    ${data.body_text.length > 300
                      ? `<span class="short-desc" data-short-desc>
                          ${data.body_text.substring(0, 300)}...
                          <a href="javascript:void(0)" class="btn-link fw-semibold text-primary ls-0" data-read-more-trigger="read-more" rel="no-follow" title="Read More" aria-label="Read More">Read More</a>
                        </span>
                        <span class="full-desc" data-full-desc style="display: none;">
                          ${data.body_text}
                          <a href="javascript:void(0)" class="btn-link fw-semibold text-primary ls-0" data-read-more-trigger="read-less" rel="no-follow" title="Read Less" aria-label="Read Less">Read Less</a>
                        </span>`
                      : `<div class="desc">${data.body_text}</div>`}
                  </div>
                  <div class="d-md-none" data-description>
                    ${data.body_text.length > 120
                      ? `<span class="short-desc" data-short-desc>
                          ${data.body_text.substring(0, 120)}...
                          <a href="javascript:void(0)" class="btn-link fw-semibold text-primary ls-0" data-read-more-trigger="read-more" rel="no-follow" title="Read More" aria-label="Read More">Read More</a>
                        </span>
                        <span class="full-desc" data-full-desc style="display: none;">
                          ${data.body_text}
                          <a href="javascript:void(0)" class="btn-link fw-semibold text-primary ls-0" data-read-more-trigger="read-less" rel="no-follow" title="Read Less" aria-label="Read Less">Read Less</a>
                        </span>`
                      : `<div class="desc">${data.body_text}</div>`}
                  </div>
                </description-toggle>
              </div>` : ''}
            ${data.location ? `<span class="mb-4 d-block fs-md">${data.location}</span>` : ''}
            ${data.btn_link ? `<a href="${data.btn_link}" class="btn btn-primary">${data.btn_text || ''}</a>` : ''}
          </div>
        </div>
      </div>`;
  }

  function initModal(triggers) {
    triggers.forEach((btn) => {
      if (btn.dataset.modalBound === 'true') return;
      btn.dataset.modalBound = 'true';

      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const data = customerStoriesJson[e.currentTarget.dataset.scriptId];
        if (!data || !modalEle || !modalData) return;
        modalData.innerHTML = createModalHtml(data);
        modalEle.show();
      }, true);
    });
  }

  cardsWrapper.style.visibility = 'hidden';
  sortCardsNewestFirst();
  cardsWrapper.style.visibility = '';

  if (paginationTrigger?.hasAttribute('data-reveal-more')) {
    if (!getDeferredCards().length) {
      clearPagination();
    } else {
      armLoadMore(paginationTrigger, false);
    }
  }
});
